import { decodeGetter } from '@/app/common/components/ag-grid/configs';
import SubtleBadge from '@/components/common/SubtleBadge';
import { massiveDetailColumnConfig } from './massiveDetailColumnConfig';

const menuTabs = ['columnsMenuTab', 'filterMenuTab', 'generalMenuTab'];

const filterModeLabels: Record<string, string> = {
  exclude: 'حذف',
  include: 'شامل'
};

const excludedGroupTitles = new Set(['جستجو', 'سنجه‌های کلمه']);

const [, ...detailColumnsAfterKeyword] = massiveDetailColumnConfig.filter(
  column => !('gp' in column && excludedGroupTitles.has(column.gp as string))
);

const grandParentIndex = detailColumnsAfterKeyword.findIndex(
  column => column.field === 'grand_parent_keyword'
);

const columnsBeforeFilterMode = detailColumnsAfterKeyword
  .slice(0, grandParentIndex + 1)
  .map(column =>
    column.field === 'grand_parent_keyword'
      ? { ...column, width: 160 }
      : column
  );
const columnsAfterFilterMode = detailColumnsAfterKeyword.slice(
  grandParentIndex + 1
);

const filterModeColumn = {
  field: 'filter_mode',
  type: 'string',
  title: 'نوع فیلتر',
  width: 110,
  searchable: true,
  filter: 'agTextColumnFilter',
  floatingFilter: true,
  menuTabs,
  cellRenderer: (params: { value?: string }) => {
    if (!params.value) return '';
    const isExclude = params.value === 'exclude';
    return (
      <div className="w-100 d-flex h-100 align-items-center">
        <SubtleBadge
          pill
          bg={isExclude ? 'danger' : 'success'}
          className="d-flex align-items-center gap-1 fs--2"
        >
          {filterModeLabels[params.value] ?? params.value}
        </SubtleBadge>
      </div>
    );
  }
};

const filterTermsColumn = {
  field: 'filter_terms',
  type: 'array',
  title: 'عبارات فیلتر',
  width: 200,
  minWidth: 150,
  searchable: true,
  filter: 'agTextColumnFilter',
  floatingFilter: true,
  menuTabs,
  filterValueGetter: (params: { data?: { filter_terms?: string[] } }) =>
    params.data?.filter_terms
      ?.map(term => decodeURIComponent(term))
      .join(' ') ?? '',
  cellRenderer: (params: {
    value?: string[];
  }) => {
    if (!params.value?.length) return '';
    return (
      <div className="w-100 d-flex h-100 align-items-center flex-wrap gap-1">
        {params.value.map((term, i) => (
          <SubtleBadge
            pill
            key={i}
            bg="info"
            className="d-flex align-items-center gap-1 fs--2"
          >
            {decodeURIComponent(term)}
          </SubtleBadge>
        ))}
      </div>
    );
  }
};

export const massiveExcludedColumnConfig = [
  massiveDetailColumnConfig[0],
  {
    filterValueGetter: decodeGetter,
    field: 'user_keyword',
    type: 'string',
    title: 'کلمه کاربر',
    width: 200,
    minWidth: 150,
    searchable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    menuTabs
  },
  ...columnsBeforeFilterMode,
  filterModeColumn,
  filterTermsColumn,
  ...columnsAfterFilterMode
];
